<div class="table-responsive list-wrapper-bordered">
    <table class="table table-striped table-hover table-borderless border-0" >
        <thead>
        <tr>
            <th class="text-nowrap">Title</th>
            <th class="text-nowrap">Provider</th>
            <th class="text-nowrap">Date Earned</th>
            <th class="text-nowrap">Date Expired</th>
            <th class="text-nowrap">Attendance Type</th>
            <th class="text-nowrap">Certification ID</th>
            <th class="sticky-action"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let cert of userCerts">
            <td class="text-nowrap" style="color: #000;">{{ cert.certification.certificationTitle }}</td>
            <td class="text-nowrap" style="color: #000;">{{ cert.certification.association.providerName }}</td>
            <td class="text-nowrap" style="color: #000;">{{ cert.acquiredDate | date : "MM/dd/y" }}</td>
            <td class="text-nowrap" style="color: #000;">{{ cert.expiresDate | date : "MM/dd/y" }}</td>
            <td class="text-nowrap" style="color: #000;">{{maskingColumn('parameterLabel', 'parameterValue', attendanceTypes.parameterMembers, cert.attendanceType)}}</td>
            <td class="text-nowrap" style="color: #000;">{{ cert.providerAssignedId }}</td>
            <td class="sticky-action">
                <button (click)="updateCertification(cert)" style="color:#5B25B4" mat-icon-button aria-label="edit certification">
                    <mat-icon>edit_square</mat-icon>
                </button>

            </td>
        </tr>
        <tr *ngIf="userCerts.length == 0">
            <td colspan="7" class="text-center">
                <span>No Certifications available </span>
            </td>
        </tr>
        </tbody>
    </table>
</div>
<div class="mt-4" *ngIf="userCerts.length > 0">
    <app-pagination
            (goPage)="toPage($event)"
            (goPerPage)="perPageSet($event)"
            [pagesToShow]="showPages"
            [page]="pageNo"
            [perPage]="pageSize"
            [count]="totalRow"></app-pagination>
</div>
